<template>
  <div>
    <v-dialog
      scrollable
      v-model="showOneAwayFromHomeDialog"
      max-width="450px"
      persistent
    >
      <v-form ref="formOneAway" v-model="valid" lazy-validation>
        <v-card v-if="selectedOneAway">
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="text-center">
                  <span
                    >Estas a más de 5KM del punto habitual de fin de ruta.
                    Escribe la dirección donde finalizas la ruta.</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="selectedOneAway.address"
                    v-bind:label="$t('address')"
                    v-if="this.isManualAddress"
                    outlined
                    class="editpos_input"
                    :readonly="this.isManualAddress"
                    :rules="this.isManualAddress ? requiredRules : []"
                  ></v-text-field>
                  <input
                    v-model="selectedOneAway.address"
                    type="text"
                    :placeholder="$t('address')"
                    ref="googleaddressbar"
                    class="googleAddressFinder pac-target-input"
                    autocomplete="off"
                    required
                    v-show="!this.isManualAddress"
                    :readonly="this.isManualAddress"
                  />
                  <!-- Error message for Google Places input -->
                  <div
                    v-if="!this.isManualAddress && showAddressError"
                    class="v-messages error--text"
                  >
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message">
                        La dirección es obligatoria.
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row class="mb-1" v-if="manualData" v-show="isManualAddress">
                <v-col cols="12" sm="12" md="12">
                  <h6 class="my-2">
                    Introduce manualmente la nueva dirección:
                  </h6>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="manualData.address"
                        v-bind:label="$t('address')"
                        required
                        :rules="this.isManualAddress ? requiredRules : []"
                      ></v-text-field>
                      <!-- Error message for Google Places input -->
                  <div
                    v-if="this.isManualAddress && showAddressError"
                    class="v-messages error--text"
                  >
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message">
                        La dirección es obligatoria.
                      </div>
                    </div>
                  </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" offset-sm="0" md="12">
                  <div class="text-right">
                    <a style="color: #1976d2;" @click="toggleCantfindAddress">
                      La dirección no sale
                    </a>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12" class="text-center">
                  <span>Puedes indicar el motivo?</span>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="selectedOneAway.motivo"
                    v-bind:label="'Motivo'"
                    required
                    :rules="[
                      v => !!v || 'Motivo is required.', // Ensures the field is not empty
                      v =>
                        (v && v.trim() !== '') ||
                        'Motivo cannot be just spaces.' // Ensures the field is not just spaces
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click.stop="cancelDialog">
              {{ $t("cancel") }}
            </v-btn> -->
            <v-btn
              color="blue darken-1"
              text
              :loading="isSaving"
              :disabled="isSaving"
              @click="onClickOneAwayFromHome"
              ref="btnSave"
            >
              {{ $t("save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-overlay :value="isSaving" z-index="9999">
      <v-progress-circular
        indeterminate
        size="70"
        width="7"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import haversine from "haversine-distance";
import ApiService from "../../services/apiService";

export default {
  name: "DialogEndKM",
  props: ["value", "session", "mainRoute", "currentPosition"],
  data: function() {
    return {
      valid: true,
      requiredRules: [v => !!v || "Required"],
      isSaving: false,
      showOneAwayFromHomeDialog: false,
      selectedOneAway: null,
      isManualAddress: false,
      addressAutoComplete: null,
      manualData: null,
      showAddressError: false
    };
  },
  computed: {
    ...mapGetters("auth", ["user"])
  },
  watch: {
    value: function(newValue) {
      if (newValue) {
        this.checkOneAwayFromHome();
      }
    }
  },
  methods: {
    async toggleCantfindAddress() {
      this.isManualAddress = !this.isManualAddress;
      this.showAddressError = false; // Reset error when switching modes

      if (this.isManualAddress) {
        this.manualData = {
          address: ""
        };
      }
    },
    onGoogleMapInit() {
      this.$nextTick(() => {
        setTimeout(() => {
          const input = this.$refs.googleaddressbar;
          if (input && window.google?.maps?.places) {
            this.addressAutoComplete = new window.google.maps.places.Autocomplete(
              input
            );
            this.addressAutoComplete.addListener(
              "place_changed",
              this.placeChangedListener
            );
          } else {
            console.warn("Google Maps library not loaded or input missing");
          }
        }, 800);
      });
    },
    placeChangedListener() {
      var address = this.addressAutoComplete.getPlace();
      if (address && address.formatted_address) {
        this.selectedOneAway.address = address.formatted_address;
        this.showAddressError = false; // Hide error when address is selected
      }
    },
    async getLatLngFromPostalCode(postalCode) {
      return new Promise(resolve => {
        if (!postalCode) {
          return resolve(null);
        }
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: postalCode }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            const lat = location.lat();
            const lng = location.lng();
            resolve({ lat, lng });
          } else {
            resolve(null);
          }
        });
      });
    },
    async checkOneAwayFromHome() {
      if (this.currentPosition && this.user) {
        let distance = null;
        let posLocationPt = {
          lat: this.currentPosition.latitude,
          lng: this.currentPosition.longitude
        };
        let userLocationPt = await this.getLatLngFromPostalCode(
          this.user.postalCode
        );

        if (userLocationPt) {
          distance = haversine(posLocationPt, userLocationPt);
        }

        if (
          distance &&
          distance >= 5000
        ) {
          this.selectedOneAway = {
            address: null,
            motivo: null
          };
          this.showOneAwayFromHomeDialog = true;
          this.onGoogleMapInit();
        } else {
          this.$emit("savingEndKM", {
            end_wrong: false,
            end_wrong_comment: ""
          });
          this.$emit("input", false);
        }
      } else {
        this.$emit("savingEndKM", { end_wrong: false, end_wrong_comment: "" });
        this.$emit("input", false);
      }
    },
    async onClickOneAwayFromHome() {
      if (this.isSaving) return;
      // Validate the form first
      if (this.$refs.formOneAway.validate()) {
        let address = this.isManualAddress
          ? this.manualData?.address
          : this.selectedOneAway?.address;
        let motivo = this.selectedOneAway?.motivo;

        // Address validation
        if (!address || address.trim() === "") {
          this.showAddressError = true;
          return;
        } else {
          this.showAddressError = false;
        }

        // Prepare data for API
        let data = {
          address,
          motivo,
          end_wrong: true,
          end_wrong_comment: motivo || "",
          sessionId: this.session?.id,
          mainRoute: this.mainRoute,
          currentPosition: this.currentPosition
        };

        this.isSaving = true;
        try {
          // Call your API here
          const resp = await ApiService.post(
            `worksession/wrong_location`,
            data
          );
          console.log("Response from API: ", resp.status);
          if (resp && resp.success) {
            // Emit event to parent to continue the flow
            // Keep the loader visible until the parent moves to the next screen
            this.$emit("savingEndKM", data);
            // this.closeDialogs();
          } else {
            // Handle API error (show message, etc.)
            this.isSaving = false;
            this.$toast &&
              this.$toast.error(
                "No se pudo guardar la dirección de fin de ruta."
              );
          }
        } catch (e) {
          this.$emit("savingEndKM", data);
          // this.closeDialogs();
        }
      }
    },
    cancelDialog() {
      this.$emit("savingEndKM", { end_wrong: false, end_wrong_comment: "" });
      this.closeDialogs();
    },
    closeDialogs() {
      this.showOneAwayFromHomeDialog = false;
      this.$emit("input", false);
      this.isSaving = false;
      this.showAddressError = false; // Reset error state
    }
  }
};
</script>

<style>
input.googleAddressFinder {
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition-property: height, min-height;
  margin-top: 16px;
  font-size: 16px;
  height: 33px;
}

/* Error message styling to match Vuetify */
.v-messages.error--text {
  color: #ff5252 !important;
}

.v-messages__wrapper {
  min-height: 14px;
}

.v-messages__message {
  font-size: 12px;
  line-height: 14px;
  margin-top: 4px;
}
</style>
